import React, { useContext, useEffect, useState } from 'react';
import { ConfigContext } from '../Context/ConfigContext';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart } from '../Redux/features/Cart/CartSlice';
import { ToastContainer, toast } from 'react-toastify';
import { formatSlug } from '../Utils/Helper';
import GlobalCards from '../Utils/GlobalCards';
import CardShimmer from '../Utils/shimmerEffect/CardShimmer';

const PopularProducts = () => {
    const { apiURL, apiHeaderJson, currencyValue } = useContext(ConfigContext);
    const dispatch = useDispatch()
    const wishList = useSelector(state => state.Wishlist)
    const navigate = useNavigate()
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expandedId, setExpandedId] = useState(null);

    const GetProducts = async () => {
        setLoading(true)
        try {
            const response = await axios.get(`${apiURL}Home/GetHomeProducts`, { params: { limit: 5 }, headers: apiHeaderJson });
            setData(response?.data?.data?.data);
            setLoading(false)
        } catch (error) {
            console.error(error)
        }
    };

    const toggleExpansion = (id) => {
        setExpandedId(expandedId === id ? null : id);
    };

    const PageRoute = () => {
        navigate("/AllProductsList")
    }

    const handleAddToCart = (product) => {
        const newProduct = { ...product, selected_currency: currencyValue }
        dispatch(addToCart(newProduct))
        toast.success(`${product.product_title} Added`, {
            position: "bottom-center",
        })
    }

    const CheckWishList = (product_id) => {
        return wishList.some((item) => item.product_id === product_id);
    }

    const handleProductDetails = (product) => {
        if (product) {
            navigate(`/ProductDetails/${formatSlug(product.product_title)}=${product.product_id}`)
        }
    }

    useEffect(() => {
        GetProducts();
    }, []);

    return (
        <>
            <ToastContainer />
            <section className="product-tabs section-padding position-relative">
                <div className="container">
                    <div className="section-title style-2 wow animate__animated animate__fadeIn mb-30">
                        <h3>Popular Products</h3>
                        <ul className="nav nav-tabs links" id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <Link to="/AllProductsList">
                                    <button onClick={PageRoute} className="nav-link active" id="nav-tab-one" data-bs-toggle="tab" data-bs-target="#tab-one" type="button" role="tab" aria-controls="tab-one" aria-selected="true">
                                        All Popular Products
                                    </button>
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade show active" id="tab-one" role="tabpanel" aria-labelledby="tab-one">
                            <div className="row product-grid-4">
                                {
                                    data.map((item, i) => (
                                        <GlobalCards
                                            item={item}
                                            handleProductDetails={() => handleProductDetails(item)}
                                            handleAddToCart={handleAddToCart}
                                            CheckWishList={CheckWishList(item?.product_id)}
                                        />
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </>
    );
};

export default PopularProducts;
